import enUS from "./en-US"
import esES from "./es-ES"

export const errorTranslations = {
  "en-US": enUS,
  "es-ES": esES,
}
